import { apiGetCard, fetchCards, selectedCards } from '@shared-core/features/backend'
import { useAppDispatch, useAppSelector } from '@shared-core/store'
import { isAcceptableAmountInput } from '@shared-core/utils/balances/balances'
import { Big } from '@shared-core/utils/balances/big'
import { useEffect, useMemo, useState } from 'react'

function readBalance(value: string): string | null {
  return value !== '' && isAcceptableAmountInput(value) && Big(value).gte(0) ? value : null
}

// Обновляем баланс выбранной карты; до ответа используем доступные данные из списка карт.
export function useWithdrawCardBalance(requestedCardId?: string) {
  const cards = useAppSelector(selectedCards)
  const dispatch = useAppDispatch()
  const card = useMemo(
    () =>
      cards?.find((item) =>
        requestedCardId ? item.id === requestedCardId : item.status === 'active' || item.status === 'frozen',
      ),
    [cards, requestedCardId],
  )
  const cardId = requestedCardId ?? card?.id
  const cachedBalance = card ? readBalance(card.balance) : null
  const [loaded, setLoaded] = useState<{ cardId: string; balance: string | null } | null>(null)

  useEffect(() => {
    if (!cards && !requestedCardId) void dispatch(fetchCards())
  }, [cards, dispatch, requestedCardId])

  useEffect(() => {
    if (!cardId) return
    let active = true
    void apiGetCard({ routeParams: { id: cardId } }).then((response) => {
      if (active && response?.data) {
        setLoaded({ cardId, balance: readBalance(response.data.balance) })
      }
    })
    return () => {
      active = false
    }
  }, [cardId])

  return { cardId, balance: loaded && loaded.cardId === cardId ? loaded.balance : cachedBalance }
}
